import type { ReactNode } from 'react';

import { cn } from '@crm/shared/lib';

interface DealDetailsBlockProps {
    title: string;
    className?: string;
    children?: ReactNode;
    renderHederContent?: () => ReactNode;
}

export const DealDetailsBlock = ({
    title,
    className,
    children,
    renderHederContent,
}: DealDetailsBlockProps) => (
    <section
        className={cn(
            'flex w-full min-w-0 flex-col items-start justify-start gap-4 self-stretch overflow-hidden rounded-xl p-5 outline-1 -outline-offset-1 outline-gray-200',
            className
        )}
    >
        <div className="flex w-full min-w-0 items-center justify-between gap-3">
            <h2 className="min-w-0 flex-1 truncate text-base leading-5 font-bold text-gray-800">
                {title}
            </h2>
            {renderHederContent?.()}
        </div>
        {children}
    </section>
);
